import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { LosDiscountTableOverlayComponent } from './los-discount-table-overlay.component'

@Injectable()
export class LosDiscountTableOverlayService {
  constructor(private dialog: DialogService) {}

  open(data?: { channelId?: string; rentalId?: string }) {
    const defaultConfig: MatDialogConfig = {
      data: { ...data },
      panelClass: ['drawer-full-80'],
    }

    const dialogRef = this.dialog.openDrawer(LosDiscountTableOverlayComponent, defaultConfig)

    return dialogRef
  }
}
